import { ScrollPanel } from 'primereact/scrollpanel'
import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { IoSearchOutline } from 'react-icons/io5'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { FetchTaskUserSubmissionData } from '../../../../Redux/Actions/TaskCreatorAction'

import { FaSpinner } from 'react-icons/fa'
import DashboardFooter from '../../../Common/DashboardFooter'
import SubmissionRow from './SubmissionRow'
import CustomPagination from '../../../Common/CusstomPagination'

const CreatorTaskSubmissions = () => {
    const [submissionsData, setSubmissionsData] = useState([])
    // const[totalL]
    const [sortOrder, setSortOrder] = useState('asc');
    const location = useLocation()
    const [totalLength, setTotalLength] = useState(0);
    const dispatch = useDispatch()
    const subSlugId = location.state.id.slug
    const [loader, setLoader] = useState({
        fetch: true,
        approve: false,
        reject: false
    })
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItemOnPage: 20
    });

    const handleSort = () => {
        const sortedData = [...submissionsData].sort((a, b) => {
            if (sortOrder === 'asc') {
                return new Date(a.createdat) - new Date(b.createdat);
            } else {
                return new Date(b.createdat) - new Date(a.createdat);
            }
        });
        setSubmissionsData(sortedData);
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    }


    const fetchData = () => {
        let SubData = {
            "slug": subSlugId,
            "page": pagination.currentPage || 1
        }

        dispatch(FetchTaskUserSubmissionData(SubData, loader, setSubmissionsData, setLoader, setTotalLength))
    }


    useEffect(() => {
        if (subSlugId) {
            fetchData()
        }

    }, [subSlugId, pagination.currentPage])
    return (
        <>
            <div className="custombar2  content-area">
                <div className="content-area-in">
                    <div className="account-block bg-transparent p-0 me-3">
                        <div className="table-bar">
                            <div className="table-bar-left">
                                <div className="table-bar-icon">
                                    <div className="table-nav">
                                        <div className="profile-menu">

                                        </div>

                                    </div>
                                    <ul>
                                        <li title="Sort by Date">
                                            <img src={require("../../../../images/icon/sort.svg").default} alt="" onClick={handleSort} />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="table-bar-right">
                                <div className='d-flex align-items-center gap-3 bar-btns'>
                                    <div className="header-search">
                                        <input
                                        
                                            type="text"
                                            placeholder="Search"
                                            name="searchInput"
                                        // value={searchInput}
                                        // onChange={(e) => setSearchInput(e.target.value)}

                                        />

                                        <span className="left-icon"><IoSearchOutline
                                        /></span>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="table-responsive badge-mob table-scroll earnings_table mt-3">
                            {loader.fetch ?
                                <div className="d-flex align-items-center justify-content-center mt-4"><FaSpinner className="spin ms-1" style={{ fontSize: "40px", height: "100vh" }} /></div> :
                                <table className="table theme-table">
                                    <thead>
                                        <tr>

                                            <th>Id</th>
                                            <th>Proof</th>
                                            <th>Proof Data</th>

                                            <th>Status</th>
                                            <th>Created</th>

                                            <th>Action
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>


                                        {submissionsData.length > 0 ? submissionsData.map((curElem, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <SubmissionRow curElem={curElem} loader={loader} setLoader={setLoader} fetchData={fetchData} />

                                                </React.Fragment>
                                            )
                                        }

                                        ) :
                                            <td className='text-center mt-3 pt-2' colSpan={7}>No submission available</td>
                                        }


                                    </tbody>

                                </table>}
                            <div className='my-3'>

                                <CustomPagination
                                    pagination={pagination}
                                    setPagination={setPagination}
                                    totalLength={totalLength}
                                    loader={loader.fetch}
                                />

                            </div>

                        </div>
                    </div>
                </div>
            </div >
            <div style={{ marginTop: "42px" }}>
                <DashboardFooter />
            </div>
        </>

    )
}

export default CreatorTaskSubmissions
